<template>
	<div class="is-flex is-flex-direction-row mt-2 mb-4 gap-custom">
		<div v-if="showCounterpartCard" class="card-custom is-flex-grow-1">
			<p class="header-card">Clasificación por contraparte</p>
			<p class="progressTextContent">
				<span class="numberProgress">
					{{ classifiedByCounterpart }} /
					{{ total }}
				</span>
				<span class="textProgress">Clasificados</span>
			</p>
			<div class="progress-container">
				<div class="progress-bar"
					:style="{ width: classifiedByCounterpart / total * 100 + '%' }">
				</div>
			</div>
		</div>
		<div class="card-custom is-flex-grow-1">
			<p class="header-card">Clasificación por documento</p>
			<p class="progressTextContent">
				<span class="numberProgress">
					{{ classifiedByDocument }} /
					{{ total }}
				</span>
				<span class="textProgress">Clasificados</span>
			</p>
			<div class="progress-container">
				<div class="progress-bar"
					:style="{ width: classifiedByDocument / total * 100 + '%' }">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ProgressCards",
	props: {
		showCounterpartCard: { type: Boolean, default: true },
		classifiedByCounterpart: { type: Number, default: 0 },
		classifiedByDocument: { type: Number, default: 0 },
		total: { type: Number, default: 0 },
	},
};
</script>

<style scoped lang="scss">
.gap-custom {
	gap: 24px;
}

.card-custom {
	padding: 12px 24px;
	border-radius: 12px;
	border: 1px solid var(--Gray-200, #EAECF0);
	background: var(--Base-White, #FFF);
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

	.header-card {
		color: var(--Gray-700, #344054);
		font-size: 14px;
		font-weight: 500;
		line-height: 20px;
		margin-bottom: 12px;
	}

	.progressTextContent {
		color: var(--Gray-600, #475467);
		font-size: 12px;
		line-height: 20px;

		.numberProgress {
			font-weight: 700;
		}

		.textProgress {
			font-weight: 400;
		}
	}
}

.progress-container {
	width: 100%;
	height: 8px;
	background-color: var(--Gray-200, #EAECF0);
	border-radius: 4px;
	overflow: hidden;
}

.progress-bar {
	height: 100%;
	background-color: #00A9AD;
	transition: width 0.3s ease-in-out;
}
</style>
